// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4c8f6102","453":"17910525","732":"3458b998","977":"9ef59551"}[chunkId] + ".chunk.js";
};